import type { SxProps, Theme } from "@mui/material/styles";
import { colors } from "../../../../../utils/colors";

export const genericDonutDefaultColors = [
  colors.bar_gray,
  colors.legend_orange,
  colors.chart_blue,
  colors.bar_lavender,
];

export const genericDonutChartConfig = {
  innerRadius: "45%",
  outerRadius: "70%",
  labelLineLength: 12,
  labelLineLength2: 8,
  sliceBorderWidth: 2,
  emptyStateMinHeight: 280,
};

export const genericDonutTooltipTextStyle = {
  color: colors.chart_text,
  fontSize: "0.75rem",
  fontWeight: 400,
};

export const genericDonutSliceItemStyle = {
  borderColor: colors.white,
  borderWidth: genericDonutChartConfig.sliceBorderWidth,
};

export const genericDonutLabelStyle = {
  show: true,
  position: "outside" as const,
  formatter: "{b}",
  color: colors.chart_text,
  fontSize: "0.75rem",
  fontWeight: 500,
};

export const genericDonutLabelLineStyle = {
  show: true,
  length: genericDonutChartConfig.labelLineLength,
  length2: genericDonutChartConfig.labelLineLength2,
};

export const getGenericDonutTitleSx = (
  titleAlign: "left" | "center" | "right",
): SxProps<Theme> => ({
  px: 2,
  mb: "0.25rem",
  fontWeight: 500,
  fontSize: "16px",
  color: colors.grayish_blue,
  textAlign: titleAlign,
});

export const genericDonutChartStyles = {
  root: {
    minWidth: 0,
  },
  emptyStateContainer: {
    minWidth: 0,
    px: 2,
    py: 6,
    minHeight: genericDonutChartConfig.emptyStateMinHeight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  chartWrapper: (minHeight: number, loading: boolean, hasData: boolean) => ({
    minHeight,
    px: 2,
    opacity: loading && !hasData ? 0.5 : 1,
    minWidth: 0,
  }),
  chartCanvas: (height: number) => ({
    width: "100%",
    minWidth: 0,
    height,
  }),
  chartPlaceholder: (minHeight: number) => ({
    width: "100%",
    minHeight,
    minWidth: 0,
  }),
};
